import { defineStore } from 'pinia';
export const useAuthStore = defineStore('authStore', {
    state: () => ({
        user: null,
        isAuthenticated: false,
        game: null,
        liveGame: null,
    }),
    actions: {
        setUser(user) {
            this.user = user;
            this.isAuthenticated = true;
        },
        clearUser() {
            this.user = null;
            this.isAuthenticated = false;
        },
        setGame(game) {
            this.game = game;
        },
        setCasinoGame(liveGame) {
            this.liveGame = liveGame;
        }
    },
    getters: {
        getGame(state) {
            return state.game;
        },
        getCasinoGame(state) {
            return state.liveGame;
        }
    },
});
